<template>
  <div class="weather-settings-show">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>累積気温</span>
          </li>
        </ul>
      </div>
      <!-- <h1 class="title">累積気温</h1> -->
    </div>
    <div class="section">
      <div class="container">
        <div id="button-area">
          <span class="btn-submit" :class="{ disable: isReadOnly }" @click="WorkItemAdd">追加</span>
        </div>
        <table class="stripe">
          <tr>
            <th class="text-no">#</th>
            <th>名称</th>
            <th class="text-date">起算日</th>
            <th class="text-cumulative">累積目標値</th>
          </tr>
          <tr
            v-for="(row, index) in wheatherSettings"
            :key="row.setting_id"
            @click="WorkItemEdit(row.setting_id)"
          >
            <td class="text-centered">{{ index + 1 }}</td>
            <td>{{ row.name }}</td>
            <td class="text-centered">{{ DisplayDateTime(row.datetime) }}</td>
            <td class="text-centered">{{ row.cumulative }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";

export default {
  components: {},

  mixins: [Loader],

  props: {},

  data() {
    return {
      wheatherSettings: [],
      isReadOnly: false,
    };
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      try {
        this.wheatherSettings = await this.retrieveWeatherSettings();
        this.isReadOnly = this.isPastManagement();
      } catch (error) {
        console.log(error);
        alert(error);
      }      
    });
  },

  methods: {
    ...mapActions(["retrieveWeatherSettings"]),
    ...mapGetters(["isPastManagement"]),

    WorkItemAdd: function () {
      this.$router.push({ name: "weather-settings-add" });
    },
    WorkItemEdit: function (id) {
      this.$router.push({
        name: "weather-settings-edit",
        params: { viewMode: "e", setting_id: id },
      });
    },
    DisplayDateTime: function (datetime) {
      return datetime.replace(/-/g, "/");
    },
  },
};
</script>

<style lang="scss">
.weather-settings-show {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 80%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;
    }
  }
  table {
    //    margin: 30px auto 30px;
    width: 100%;
    border: solid 1px #ddd;
    font-size: 0.9rem;
    background: #fff;
    /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
  }
  th {
    padding: 8px;
    border-bottom: solid 1px #bbb;
    border-right: solid 1px #bbb;
    background: #ccc;
    font-weight: normal;

    &.text-no {
      width: 10%;
    }
    &.text-date {
      width: 20%;
    }
    &.text-cumulative {
      width: 20%;
    }
  }

  th:nth-child(0) {
    border-right: none;
  }

  td {
    padding: 8px;
    border-bottom: solid 1px #ddd;
    border-right: solid 1px #ddd;
    cursor: pointer;

    &.text-centered {
      text-align: center;
    }
    &.text-right {
      text-align: right;
    }
    &.text-left {
      text-align: left;
    }
  }

  td:nth-child(0) {
    border-right: none;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }
  #edit-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  #edit-area span {
    display: block;
    font-size: 14px;
    padding: 3px 0px;
    margin: 10px 0;
    text-align: center;
    color: var(--purple);
  }

  #edit-area span.active {
    border-bottom: solid 4px var(--purple);
    cursor: pointer;
  }

  #edit-area span::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 0 0 15px;
  }
  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  .btn-submit {
    display: block;
    background: var(--purple);
    font-size: 14px;
    text-align: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    color: #fff;
    padding: 6px 20px;
    // margin: 10px auto 10px;
    margin-bottom: 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_wb-sunny.svg") no-repeat center center;
  }
}
</style>
